/**
 * Skincare Cards - Swiper carousel
 * Desktop: 3 cards | Mobile: 1.2 cards per view
 */
(function () {
  const DESKTOP_BREAKPOINT = 750;

  function init(el) {
    if (!el || el.swiper) return;

    if (typeof Swiper === "undefined") {
      setTimeout(() => init(el), 50);
      return;
    }

    const container = el.closest(".skincare-cards-swiper") || el.parentElement;
    const prevEl = container?.querySelector(".skincare-cards-prev");
    const nextEl = container?.querySelector(".skincare-cards-next");

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    const slideCount = el.querySelectorAll(".swiper-slide").length;

    const swiper = new Swiper(el, {
      slidesPerView: 1.2,
      spaceBetween: 20,
      slidesPerGroup: 1,
      loop: false,
      rewind: !prefersReducedMotion && slideCount > 1,
      speed: 400,
      observer: true,
      observeParents: true,
      breakpoints: {
        750: {
          slidesPerView: 3,
          spaceBetween: 24
        }
      },
      a11y: { enabled: true },
      navigation:
        prevEl && nextEl
          ? {
              prevEl,
              nextEl
            }
          : {},
      on: {
        init(s) {
          const ro = new ResizeObserver(() => s.update());
          ro.observe(el);
          el._swiperResizeObserver = ro;
        }
      }
    });

    el.swiper = swiper;
  }

  function initAll(container = document) {
    container.querySelectorAll(".js-skincare-cards-swiper").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => setTimeout(initAll, 100));
  } else {
    setTimeout(initAll, 100);
  }

  document.addEventListener("shopify:section:load", (e) => {
    initAll(e.target);
  });

  document.addEventListener("shopify:section:unload", (e) => {
    e.target.querySelectorAll(".js-skincare-cards-swiper").forEach((el) => {
      if (el._swiperResizeObserver) {
        el._swiperResizeObserver.disconnect();
      }
      if (el.swiper) {
        el.swiper.destroy(true, true);
        el.swiper = null;
      }
    });
  });
})();
